/**
 * Sentry fuera del chunk de entrada (2026-10-28).
 *
 * `@sentry/react` pesaba en `main.js` aunque nada de él hace falta para el
 * primer pintado. Se carga aparte, después de pintar (`trasPrimerPintado`, la
 * misma señal que ya usa App Check), y quien reporta un error antes de que haya
 * llegado no lo pierde: `reportarError` espera a que cargue y lo manda igual.
 *
 * LO QUE SE ACEPTA A CAMBIO: un error global no atrapado (fuera de un
 * ErrorBoundary) en los primeros instantes, antes de que Sentry se inicialice,
 * no se registra. Los fallos de render los sigue reportando `ErrorBoundary`.
 */
let cargando = null;

export function cargarSentry() {
  if (!cargando) {
    cargando = import('./sentryNucleo')
      .then((Sentry) => {
        if (process.env.REACT_APP_SENTRY_DSN) {
          Sentry.init({
            dsn: process.env.REACT_APP_SENTRY_DSN,
            environment: process.env.NODE_ENV,
            tracesSampleRate: 0.1,
          });
        }
        return Sentry;
      })
      .catch(() => null);
  }
  return cargando;
}

export function reportarError(error, contexto) {
  return cargarSentry().then((Sentry) => { if (Sentry) Sentry.captureException(error, contexto); });
}
